import api from '../../../lib/api';
import { ResourceFetch } from '../../../meta/types/api';
import { SalesPackage } from '../../../meta/types/billing/salespackage';
import { CONFIG } from '../../../meta/types/config';

const { GET } = api;

const SALESPACKAGE_RESOURCE_BASE_PATH = `${CONFIG.dashboardServiceBasePath}/dashboard/v1/purchase/salespackages`;

export interface SalesPackageResource {
  getPlans: ResourceFetch<SalesPackage[]>;
}

const SalesPackageResource: SalesPackageResource = {
  getPlans: GET(SALESPACKAGE_RESOURCE_BASE_PATH),
};

export default SalesPackageResource;
